import { SharedComponentsProps } from '../../../';

import * as variants from './variants';

export const AvailableVariantList = Object.keys(variants);
export type AvailableVariantListType = typeof AvailableVariantList[number];

export type LoaderProps = SharedComponentsProps & {
  /**
   * Variant style
   */
  variant?: AvailableVariantListType;
  /**
   * extra variants components
   */
  extraVariantComponents?: any; // TODO: Find the type (i'm not losing any more time on this one ><)
  /**
   * Additional loader props
   */
  additionalLoaderProps?: Record<string, unknown>;
};

export type StyledLoaderProps = {
  customStyle?: LoaderProps['customStyle'];
};
